import { useSelector } from "react-redux"
import styled from "styled-components"
import { FooterStateActions } from "store/actionCreators"
import { Link } from "react-router-dom"
import warningIcon from "images/warning.png"
import { useCallback } from "react"

export default function QuestionForm({
  visible,
  question,
  motibellNo,
  isSolved,
  errorMsg,
  hintType,
  hintLink,
  answerInputRef,
  onSubmitAnswer,
  onChangeAnswer,
  onClickExternalLink,
  ...rest
}) {
  const userInfo = useSelector((state) => state.userInfo)
  const textArr = []
  if (question) {
    const txtArr = question.split("&:")
    for (let i = 0; i < txtArr.length; ++i) {
      let txtKey = `question-txt-key-${i}`
      const closeTagPos = txtArr[i].indexOf(":&")
      if (closeTagPos !== -1) {
        const questionArr = txtArr[i].split(":&")
        for (let j = 0; j < questionArr.length; ++j) {
          txtKey = `question-txt-key-${i}-${j}`
          if (j === 0) {
            textArr.push(<HintTxt key={txtKey}>{questionArr[j]}</HintTxt>)
          } else {
            textArr.push(<QuestionTxt key={txtKey}>{questionArr[j]}</QuestionTxt>)
          }
        }
      } else {
        textArr.push(<QuestionTxt key={txtKey}>{txtArr[i]}</QuestionTxt>)
      }
    }
  }

  const hintArr = []
  if (hintType === "external_link") {
    hintArr.push(
      <ExternalLink
        key="motibell-external-link-btn"
        onClick={(e) => onClickExternalLink(e, hintLink)}
      >
        {isSolved ? "자세히 보기" : "힌트 찬스"}
      </ExternalLink>
    )
  } else if (hintType === "path") {
    hintArr.push(
      <InternalLink to={hintLink} key="motibell-internal-link-btn">
        {isSolved ? "자세히 보기" : "힌트 찬스"}
      </InternalLink>
    )
  }

  return visible === true ? (
    <FormWrapper {...rest}>
      <QuestionSection>
        {isSolved ? (
          <QuestionSolvedTxt>오늘 퀴즈 완료!</QuestionSolvedTxt>
        ) : (
          <QuestionTitle>Q. 밑줄 초성에 들어가는 단어는?</QuestionTitle>
        )}
        <QuestionBody>{textArr}</QuestionBody>
      </QuestionSection>
      {!isSolved && userInfo?.isLogin === true && (
        <>
          <AnswerSection>
            <AnswerInput
              placeholder="정답 입력"
              isError={errorMsg ? true : false}
              onChange={(e) => {
                if (onChangeAnswer) onChangeAnswer(e.currentTarget.value)
              }}
              onFocus={() => {
                FooterStateActions.updateFooterState({
                  visible: false,
                })
              }}
              onBlur={() => {
                FooterStateActions.updateFooterState({
                  visible: true,
                })
              }}
              ref={answerInputRef}
            />
            <SubmitBtn
              key={"motibell-quiz-answer-submit-btn"}
              type={"button"}
              onClick={() => {
                if (onSubmitAnswer) onSubmitAnswer()
              }}
            >
              입력
            </SubmitBtn>
          </AnswerSection>
          <ErrorSection>
            {errorMsg && (
              <ErrorMsg>
                <ErrorIconWrapper>
                  <ErrorIcon src={warningIcon} />
                </ErrorIconWrapper>
                {errorMsg}
              </ErrorMsg>
            )}
          </ErrorSection>
        </>
      )}
      {userInfo?.isLogin === true ? (
        <HintSection>{hintArr}</HintSection>
      ) : (
        <LoginBtn to={`/social?redirect_path=/motibell/${motibellNo}`}>로그인 하기</LoginBtn>
      )}
    </FormWrapper>
  ) : null
}
const FormWrapper = styled.form`
  background: #ffffff;
  border-radius: calc(100vw * (14 / 375));
  padding: calc(100vw * (26 / 375)) calc(100vw * (19 / 375));
`
const QuestionSection = styled.div``
const QuestionTitle = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #4e4e4e;
  margin-bottom: calc(100vw * (17 / 375));
`
const QuestionSolvedTxt = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (24 / 375));
  color: #2f80ed;
  margin-bottom: calc(100vw * (15 / 375));
`
const QuestionBody = styled.div`
  padding: calc(100vw * (10 / 375)) calc(100vw * (14 / 375));
  font-weight: 700;
  font-size: calc(100vw * (16 / 375));
  line-height: 156.99%;
  color: #121212;

  background: #f7f7f7;
  border-radius: calc(100vw * (11 / 375));
  min-height: 100px;
`
const AnswerSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: calc(100vw * (33 / 375));
  margin-bottom: calc(100vw * (5.5 / 375));
`
const ErrorSection = styled.div`
  height: calc(100vw * (20 / 375));
`
const ErrorMsg = styled.span`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (14 / 375));
  color: #de0000;
`
const ErrorIconWrapper = styled.span`
  display: inline-block;
  width: calc(100vw * (9.74 / 375));
  height: calc(100vw * (8.87 / 375));
  margin-right: calc(100vw * (4 / 375));
`
const ErrorIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const AnswerInput = styled.input`
  width: 100%;
  margin-right: 13px;
  border-bottom: 1.5px solid #c6c6c6;
  &::placeholder {
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 600;
    font-size: calc(100vw * (20 / 375));
    line-height: 202.99%;

    color: #c6c6c6;
  }
  &:focus {
    border-bottom: 1.5px solid #ffcf19;
    ${({ isError }) => {
      return isError === true ? "border-bottom: 1.5px solid red;" : ""
    }}
  }
  ${({ isError }) => {
    return isError === true ? "border-bottom: 1.5px solid red;" : ""
  }}
`
const SubmitBtn = styled.button`
  min-width: calc(100vw * (72 / 375));
  width: calc(100vw * (72 / 375));
  height: calc(100vw * (43 / 375));
  font-style: normal;
  font-weight: 700;
  font-size: calc(100vw * (18 / 375));
  line-height: 202.99%;
  color: white;
  background: #000000;
  border-radius: calc(100vw * (10 / 375));
`

const HintSection = styled.div``
const ExternalLink = styled.button`
  width: 100%;
  height: calc(100vw * (57 / 375));
  font-weight: 600;
  font-size: calc(100vw * (18 / 375));
  line-height: 202.99%;
  color: #000000;
  background: #ffffff;
  border: 1px solid #c6c6c6;
  border-radius: calc(100vw * (10 / 375));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: calc(100vw * (18 / 375));
`
const InternalLink = styled(Link)`
  width: 100%;
  height: calc(100vw * (57 / 375));
  font-weight: 600;
  font-size: calc(100vw * (18 / 375));
  line-height: 202.99%;
  color: #000000;
  background: #ffffff;
  border: 1px solid #c6c6c6;
  border-radius: calc(100vw * (10 / 375));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: calc(100vw * (18 / 375));
`

const QuestionTxt = styled.span``

const HintTxt = styled.span`
  color: #2f80ed;
  text-decoration: underline;
`
const LoginBtn = styled(Link)`
  display: flex;
  width: 100%;
  height: calc(100vw * (57 / 375));
  font-weight: 600;
  font-size: calc(100vw * (18 / 375));
  line-height: 202.99%;
  color: #000000;
  align-items: center;
  justify-content: center;
  border: 1px solid #c6c6c6;
  border-radius: 10px;
  margin-top: calc(100vw * (18 / 375));
`
